import { render, staticRenderFns } from "./ReportStockTables.vue?vue&type=template&id=65e15cc4&scoped=true"
import script from "./ReportStockTables.vue?vue&type=script&lang=js"
export * from "./ReportStockTables.vue?vue&type=script&lang=js"
import style0 from "./ReportStockTables.vue?vue&type=style&index=0&id=65e15cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e15cc4",
  null
  
)

export default component.exports